import axiosInstance from './Api';
import { API_VERSION } from "@/config/index";

export default {

    async contactUs(payload) {

        console.log({ payload });

        let response = await axiosInstance().post(`/${API_VERSION}/webapp/extras/contact-us`, payload);

        return response;
    },

    async adWithUs(payload) {

        let response = await axiosInstance().post(`/${API_VERSION}/webapp/extras/ad-with-us`, payload);

        return response;
    },

    async jobApplication(payload) {

        let response = await axiosInstance().post(`/${API_VERSION}/webapp/extras/job-application`, payload);

        return response;
    },

    async getCinemaNames(payload) {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/cinema_names`,{params:payload});

        return response;
    },

    async getLifeAtMiraj() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/life-at-miraj`);

        return response;
    },

    async getAboutUs() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/about-us`);

        return response;
    },

    async getContactUs() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/contact-us`);

        return response;
    },

    async getAdWithUs() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/ad-with-us`);

        return response;
    },

    async getCustomerCareEmail() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/customer-care-email`);

        return response;
    },

    async getAddress() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/address`);

        return response;
    },

    async getEmployeeTestimonials() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/extras/employee-testimonials`);

        return response;
    },
    async getInvestors() {

        let response = await axiosInstance().get(`/${API_VERSION}/webapp/investors`);

        return response;
    },
    
}


// WEBPACK FOOTER //
// ./src/apiServices/ExtrasService.js